import { createAction } from 'redux-actions';
import api from 'lib/api';

// Types
export const SET_MARQUEE_BODY = 'marquee/DEACTIVATE';
export const MARQUEE_LOAD_PENDING = 'marquee/MARQUEE_LOAD_PENDING';
export const MARQUEE_LOAD_SUCCESS = 'marquee/MARQUEE_LOAD_SUCCESS';
export const MARQUEE_MULTI_LOAD_SUCCESS = 'marquee/MARQUEE_MULTI_LOAD_SUCCESS';
export const MARQUEE_LOAD_ERROR = 'marquee/MARQUEE_LOAD_ERROR';
export const MARQUEE_DISMISS = 'marquee/MARQUEE_DISMISS';

// Actions
export const setMarqueeBody = createAction(SET_MARQUEE_BODY);
export const dismissMarquee = createAction(MARQUEE_DISMISS);

export const loadMarquee = (publisher) => api({
  endpoint: `marquee/${publisher}`,
  types: [MARQUEE_LOAD_PENDING, MARQUEE_LOAD_SUCCESS, MARQUEE_LOAD_ERROR],
});

export const loadMultiMarquee = (publisher) => api({
  endpoint: `marquees/${publisher}`,
  types: [MARQUEE_LOAD_PENDING, MARQUEE_MULTI_LOAD_SUCCESS, MARQUEE_LOAD_ERROR],
});

// Reducer
const INITIAL_STATE = {
  active: false,
  marquees: [],
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case MARQUEE_LOAD_SUCCESS: {
      const marquees = payload.data.filter((item) => !item.hidden);

      return {
        ...state,
        marquees,
        active: marquees.length > 0,
      };
    }

    case MARQUEE_MULTI_LOAD_SUCCESS: {
      if (!payload.data) {
        return state;
      }

      const { data } = payload;
      const keys = Object.keys(data);

      const embed = (item) => !item.hidden && item.marqueeType === 'embed';
      const visible = (item) => !item.hidden;
      const notNews = (pub) => pub !== 'nbcnews';

      let marquees = [];
      if (keys.length === 1) {
        // Single publisher
        marquees = data[keys[0]].marquees.filter(visible);
      } else {
        // Multiple
        marquees = [
          ...data.nbcnews.marquees.filter(embed),
          ...data[keys.filter(notNews)[0]].marquees.filter(visible),
        ];
      }

      return {
        ...state,
        marquees,
        active: marquees.length > 0,
      };
    }

    case MARQUEE_DISMISS:
      return {
        ...state,
        active: false,
        marquees: [],
      };

    default:
      return state;
  }
};
